import styled, {createGlobalStyle} from "styled-components"
import {minWidthMedia} from "@irati/ui/src/global/media"
import theme from "@irati/ui/src/global/theme"

export const DealContainer = styled.div`
  position: relative;
`

export default createGlobalStyle`
  .slick-slide:first-child ${DealContainer} {
    padding: 0 ${theme.spacing.half} 0 0;
  }
  .slick-slide:last-child ${DealContainer} {
    padding: 0 0 0 ${theme.spacing.half};
  }
  .slick-slide + .slick-slide ${DealContainer} {
    padding: 0 ${theme.spacing.half};
  }

  ${minWidthMedia.tablet`
  .slick-slide:first-child ${DealContainer} {
    padding: 0 ${theme.spacing.one} 0 0;
  }
  .slick-slide:last-child ${DealContainer} {
    padding: 0 0 0 ${theme.spacing.one};
  }
  .slick-slide + .slick-slide ${DealContainer} {
    padding: 0 ${theme.spacing.one};
  }
`}
`
